import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/effect-cards'
import 'swiper/css/autoplay'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectCards } from 'swiper/modules'
import { useStyles } from './styles'

import { CargoCaseNews } from './cargoCaseNews'
import { GigiNews } from './gigiNews'
import { EGSNews } from './egsNews.tsx'
// import { SteamOnNews } from './steamOnNews/index.tsx'
import { AppCenterNews } from './appsCenterNews/index.tsx'
import { NewYearNews } from '@/features/newsList/newYearNews'
import { XboxIntegrationNews } from '@/features/newsList/xboxIntegrationNews'
// import { LoyaltyProgramNews } from './loyaltyProgramNews/index.tsx'

export const NewsList = () => {
  const { classes } = useStyles()
  const news = [
    <XboxIntegrationNews />,
    <NewYearNews />,
    // <LoyaltyProgramNews />,
    <AppCenterNews />,
    // <SteamOnNews />,
    <GigiNews />,
    <EGSNews />,
    <CargoCaseNews />,
  ]

  return (
    <div className={classes.root}>
      <Swiper
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        direction="horizontal"
        effect="cards"
        autoplay={{
          delay: 10000,
        }}
        speed={696}
        preventInteractionOnTransition={true}
        cardsEffect={{
          perSlideOffset: 6,
          perSlideRotate: 0,
          slideShadows: false,
        }}
        modules={[EffectCards, Autoplay]}
      >
        {news.map((newsItem, idx) => (
          <SwiperSlide
            key={idx}
            className={classes.swiperSlide}
          >
            {newsItem}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
